import { Plug } from "lucide-react";
import { StickyNote } from "lucide-react";
import { ArrowDown } from "lucide-react";
import { Cpu } from "lucide-react";
import { EyeOff } from "lucide-react";
import { Settings2 } from "lucide-react";
import { Eye } from "lucide-react";
import { ArrowDownToLine } from "lucide-react";
import { CircleAlert } from "lucide-react";
import { Thermometer } from "lucide-react";
import { OctagonAlert } from "lucide-react";
import { BatteryFull } from "lucide-react";
import { CircleSlash } from "lucide-react";
import { MapPin } from "lucide-react";
import { Link2Off } from "lucide-react";
import { ArrowUp } from "lucide-react";
import { Map } from "lucide-react";
import { Tag } from "lucide-react";
import { TriangleAlert } from "lucide-react";
import { ArrowUpToLine } from "lucide-react";
import { BatteryLow } from "lucide-react";
import { Bell } from "lucide-react";
import React, {
  forwardRef,
  ReactElement,
  RefAttributes,
  useEffect,
  useRef,
  useState,
} from "react";
import "./carte_mesure.scss";
import { Icone } from "../icone/icone";
import { Sonde } from "../../types/sonde";
import { Condition } from "../../types/condition";
import { Badge, Indicator, Tooltip } from "@mantine/core";
import { Icone_signal } from "../icone/icone_signal/Icone_signal";
import { Icone_batterie } from "../icone/icone_batterie/Icone_batterie";
import { useNavigate } from "react-router-dom";
import { Extension } from "../../types/extension";
import env_config from "../../env_config";
import { DateTZ, getCurrentDate } from "../../services/GestionDates";
import "bezier-easing/src/index";
import BezierEasing from "bezier-easing/src/index";
import { Etalonnage } from "../../types/etalonnage";
import { Commentaire } from "../../types/commentaire";
import { IconName } from "lucide-react/dynamic";

export const Carte_mesure = forwardRef<
  HTMLDivElement,
  {
    titre: string;
    texte: string | undefined;
    sonde: Sonde | undefined | null;
    affichage_vrai?: string;
    affichage_faux?: string;
    handleClick: () => any;
    bg_color?: boolean;
    conditions?: Condition[];
    etalonnages?: Etalonnage[];
    afficherCondition?: boolean;
    afficherTypeSiPasIcone?: boolean;
    afficherEtatExtension?: boolean;
    extension?: Extension;
    restartTitreAnim?: string;
    date_mesure?: string;
    selected?: boolean;
    bouton_icone?: IconName | "aucun";
    bouton_onclick?: () => void;
    className?: string;
    commentaire_a_valider?: boolean;
    commentaire_mesure?: Commentaire[];
  }
>(
  (
    {
      titre,
      texte,
      sonde,
      handleClick,
      bg_color,
      affichage_vrai,
      affichage_faux,
      conditions,
      date_mesure,
      etalonnages,
      afficherCondition,
      afficherTypeSiPasIcone,
      afficherEtatExtension,
      extension,
      restartTitreAnim,
      selected,
      bouton_icone,
      bouton_onclick,
      className,
      commentaire_a_valider,
      commentaire_mesure,
    },
    ref
  ) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const titreRef = useRef<HTMLParagraphElement>(null);

    const [etalonnage_affichage, set_etalonnage_affichage] =
      useState<Etalonnage | null>(null);
    const [conditions_affichage, set_conditions_affichage] = useState<
      ReactElement[]
    >([]);
    const [couleur, set_couleur] = useState<string>("green");
    const [texte_final, set_texte_final] = useState<ReactElement>(<>{texte}</>);
    const [icone_svg, set_icone_svg] = useState(<Tag />);
    const [titre_jsx, set_titre_jsx] = useState<ReactElement>(<>{titre}</>);
    const [indicateurs, set_indicateurs] = useState<ReactElement | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
      const titreElement = titreRef.current;
      if (titreElement) {
        let is_overflowing =
          titreElement.scrollWidth > titreElement.clientWidth;
        // is_overflowing = false; //@todo supprimer cette ligne pour remettre animation
        setIsOverflowing(is_overflowing);
        if (is_overflowing) {
          const distanceToScroll =
            titreElement.scrollWidth - titreElement.clientWidth + 5;
          const pxParFrame = 1 / 70; //pixel de déplacement par frame par milliseconde
          let reverse = true;
          let translateX = 0 - +distanceToScroll;

          let easefn = BezierEasing(0.4, 0, 0.6, 1);
          if (titre === "Humidite") {
            // alert(distanceToScroll + " | " + startValue + " | " + endValue + " | " + translateX);
            // console.log(distanceToScroll + " | " + startValue + " | " + endValue + " | " + translateX + " | " + progress)
          }

          let start: DOMHighResTimeStamp,
            previousTimeStamp: DOMHighResTimeStamp;
          const animateTitle = (timeStamp: DOMHighResTimeStamp) => {
            if (start === undefined) {
              start = performance.now();
              previousTimeStamp = performance.now();
            }

            let temps_pause = 5;

            let cette_frame_pxParFrame =
              pxParFrame * (timeStamp - previousTimeStamp);

            if (titre === "Humidite") {
              // alert(distanceToScroll + " | " + startValue + " | " + endValue + " | " + translateX);
              // console.log(distanceToScroll + " | " + startValue + " | " + endValue + " | " + translateX + " | " + progress)
            }

            if (reverse) translateX -= cette_frame_pxParFrame;
            else translateX += cette_frame_pxParFrame;

            const startValue = 0 - +distanceToScroll;
            const endValue = 0;
            let progress = (translateX + startValue) / startValue - 1;
            if (progress > 1) progress = 1;
            if (progress < 0) progress = 0;

            let ease = startValue + easefn(progress) * (endValue - startValue);

            if (translateX > endValue) {
              if (translateX > endValue + temps_pause) {
                start = performance.now();
                reverse = !reverse;
              }
              if (titreRef.current)
                titreRef.current.style.transform = `translateX(${startValue}px)`;
            } else if (translateX < startValue) {
              if (translateX < startValue - temps_pause) {
                start = performance.now();
                reverse = !reverse;
              }
              if (titreRef.current)
                titreRef.current.style.transform = `translateX(${endValue}px)`;
            } else {
              if (titreRef.current)
                titreRef.current.style.transform = `translateX(${ease}px)`;
            }

            previousTimeStamp = performance.now();
            window.requestAnimationFrame(animateTitle);
          };

          window.requestAnimationFrame(animateTitle);

          // let interv = setInterval(animateTitle, 1000 / animationSpeedFPS);
          // animateTitle()
          // return () => clearInterval(interv)
        }
      }
    }, [isOverflowing]);

    useEffect(() => {
      setInterval(() => {
        const titreElement = titreRef.current;
        if (titreElement) {
          if (titreElement.scrollWidth > titreElement.clientWidth) {
            setIsOverflowing(true);
          }
        }
      }, 1000);
    }, [restartTitreAnim]);

    function timeAgo(date: Date): string {
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();

      if (diffMs < 0) return "0m"; // future dates safeguard

      const minutes = Math.floor(diffMs / (1000 * 60));
      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (days > 0) {
        return `${days}jrs`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else {
        return `${minutes}min`;
      }
    }

    useEffect(() => {
      let _texte_final = texte_final;
      let _texte_final_sans_preffix = null;
      let _texte_preffix = <></>;

      if (conditions) {
        let condi_tmp: ReactElement[] = [];
        set_couleur("green");

        if (commentaire_a_valider) set_couleur("pink");

        conditions.map((condition) => {
          switch (condition.slug) {
            case 0:
              condi_tmp.push(
                <Tooltip label={"Valeur minimum"} key={condition.id}>
                  <div className={"item"} key={condition.id}>
                    <ArrowDownToLine /> {condition.valeur_a_comparer}
                    {sonde?.affichage_suffix ?? ""}{" "}
                  </div>
                </Tooltip>
              );
              if (Number(texte) < Number(condition.valeur_a_comparer))
                set_couleur("red");
              if (Number(texte) < Number(condition.valeur_a_comparer))
                _texte_preffix = <ArrowDown />;
              break;
            case 1:
              condi_tmp.push(
                <Tooltip label={"Valeur maximum"} key={condition.id}>
                  <div className={"item"} key={condition.id}>
                    <ArrowUpToLine /> {condition.valeur_a_comparer}
                    {sonde?.affichage_suffix ?? ""}{" "}
                  </div>
                </Tooltip>
              );
              if (Number(texte) > Number(condition.valeur_a_comparer))
                set_couleur("red");
              if (Number(texte) > Number(condition.valeur_a_comparer))
                _texte_preffix = <ArrowUp />;
              break;
            case 2:
              condi_tmp.push(
                <div className={"item"} key={condition.id}>
                  <Bell /> {affichage_vrai ?? "VRAI"}{" "}
                </div>
              );
              if (texte == "0") set_couleur("red");
              break;
            case 3:
              condi_tmp.push(
                <div className={"item"} key={condition.id}>
                  <Bell /> {affichage_vrai ?? "VRAI"}{" "}
                </div>
              );

              if (texte == "1") set_couleur("red");
              break;
            case 8:
              if (condition.is_hidden) {
                // condi_tmp.push(<Tooltip label={"Detection de deconnexion automatique"} key={condition.id}>
                //         <div className={"item"} key={condition.id}><Link2Off/></div>
                //     </Tooltip>
                // )
              } else {
                condi_tmp.push(
                  <Tooltip
                    label={"Detection de deconnexion avancée"}
                    key={condition.id}
                  >
                    <div className={"item"} key={condition.id}>
                      <Link2Off />
                    </div>
                  </Tooltip>
                );
              }

              break;
            case 9:
              condi_tmp.push(
                <Tooltip
                  label={"Detection d'erreurs activée"}
                  key={condition.id}
                >
                  <div className={"item"} key={condition.id}>
                    <OctagonAlert />
                  </div>
                </Tooltip>
              );
              break;
            case 11:
              // condi_tmp.push(<Tooltip label={"Batterie de l'enregistreur faible"} key={condition.id}>
              //         <div className={"item"} key={condition.id}><BatteryLow/></div>
              //     </Tooltip>
              // )
              break;
            default:
              set_couleur("blue");
          }
        });
        set_conditions_affichage(condi_tmp);
      }

      if (etalonnages && date_mesure) {
        etalonnages.map((etal) => {
          let fin = etal.fin;
          if (!fin) fin = "2099-01-01T14:46:38Z";
          if (
            new DateTZ(date_mesure) >= new DateTZ(etal.debut) &&
            new DateTZ(date_mesure) < new DateTZ(fin)
          ) {
            set_etalonnage_affichage({ ...etal });
          }
          return etal;
        });
      }

      if (texte !== undefined) {
        if (texte === "D!") {
          set_couleur("orange");
          _texte_final = (
            <Tooltip
              label={
                "La sonde est débranché sur le port d'extension de l'enregistreur"
              }
              multiline
              zIndex={1000000}
            >
              <div
                style={{
                  display: "flex",
                  flexFlow: "column",
                  alignItems: "center",
                }}
              >
                <Link2Off />
                <div className={"inline-tag only_mobile"}>Sonde débranchée</div>
              </div>
            </Tooltip>
          );
        } else if (texte === "E!") {
          set_couleur("red");
          _texte_final = (
            <Tooltip
              label={"La mesure reçue n'a pas pu être traitée par le système."}
              multiline
            >
              <div>
                <TriangleAlert />
              </div>
            </Tooltip>
          );
        } else if (texte === "X!") {
          set_couleur("orange");
          _texte_final = (
            <Tooltip label={"La mesure n'a aucun abonnement."} multiline>
              <div>
                <EyeOff />
              </div>
            </Tooltip>
          );
        } else if (texte === "H!") {
          set_couleur("orange");
          _texte_final = (
            <Tooltip label={"Cette mesure vous est inaccessible."} multiline>
              <div>
                <EyeOff />
              </div>
            </Tooltip>
          );
        } else {
          let texte_tmp: string;
          if (sonde?.type_de_donnee === "bool") {
            texte_tmp =
              texte == "0"
                ? affichage_faux ?? "FAUX"
                : affichage_vrai ?? "VRAI";
          } else
            texte_tmp =
              (sonde?.affichage_prefix ?? "") +
              texte +
              (sonde?.affichage_suffix ?? "");
          _texte_final = (
            <>
              {_texte_preffix}
              {texte_tmp}
            </>
          );
          _texte_final_sans_preffix = <>{texte_tmp}</>;
        }
      } else {
        _texte_final = <div className={"inline-tag"}>Aucune mesure</div>;
      }

      if (texte === undefined) set_couleur("grey");
      if (sonde?.affichage_nom_mesure === "GPS") set_couleur("gps");

      if (afficherEtatExtension) {
        if (!extension) {
          set_couleur("grey");
          _texte_final = (
            <div className={"flex-col-center"}>
              {_texte_final_sans_preffix ?? _texte_final}
              <div className={"inline-tag"}>Cellule désactivée</div>
            </div>
          );
        }

        // if (extension?.cellule?.last_mesures
        //     && new DateTZ(Date.parse(extension.cellule?.last_mesures?.enregistrement)) < new DateTZ(getCurrentDate().getTime() - env_config.duree_affichage_deconnexion_capteur)) {
        if (
          (extension?.capteur.derniere_mesure &&
            new DateTZ(Date.parse(extension.capteur.derniere_mesure)) <
              new DateTZ(
                getCurrentDate().getTime() -
                  env_config.duree_affichage_deconnexion_capteur
              )) ||
          extension?.capteur.derniere_mesure == null
        ) {
          set_couleur("grey");
          _texte_final = (
            <div className={"flex-col-center"}>
              {_texte_final_sans_preffix ?? _texte_final}
              <div className={"inline-tag"}>
                Déconnecté
                {extension?.capteur.derniere_mesure
                  ? " (" +
                    timeAgo(
                      new DateTZ(Date.parse(extension.capteur.derniere_mesure))
                    ) +
                    ")"
                  : ""}
              </div>
            </div>
          );
        }
      }

      if (sonde) {
        switch (sonde.slug_type) {
          case "gps":
            set_icone_svg(<Map />);
            break;
          case "temperature":
            set_icone_svg(<Thermometer />);
            break;
          case "contact sec NO":
            set_icone_svg(<Plug />);
            break;
          case "contact sec NF":
            set_icone_svg(<Plug />);
            break;
          case "batterie":
            set_icone_svg(<BatteryFull />);
            break;
          case "aucune sonde":
            set_icone_svg(<CircleSlash />);
            break;
          default:
            if (afficherTypeSiPasIcone)
              set_titre_jsx(
                <>
                  <i>{sonde.affichage_nom_mesure} </i>&nbsp;- {titre}
                </>
              );
            else set_titre_jsx(<>{titre}</>);
        }
      }

      if (selected) set_icone_svg(<MapPin />);

      if (extension?.capteur.niveau_batterie || extension?.capteur?.rssi) {
        set_indicateurs(
          <>
            <div
              className={"conditions"}
              style={{ justifyContent: "space-between" }}
            >
              {extension.capteur.niveau_batterie && (
                <div
                  className={"item"}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(
                      "/capteur/" +
                        extension.capteur.uuid +
                        "?cellule=" +
                        extension.cellule?.id
                    );
                  }}
                >
                  <Tooltip
                    label={extension.capteur.niveau_batterie + "%"}
                    position={"right"}
                  >
                    <div>
                      <Icone_batterie
                        niveau_batterie={extension.capteur.niveau_batterie}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
              {extension?.capteur?.rssi && (
                <div
                  className={"item"}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(
                      "/capteur/" +
                        extension.capteur.uuid +
                        "?cellule=" +
                        extension.cellule?.id
                    );
                  }}
                >
                  <Tooltip
                    label={extension.capteur.rssi + "dBm"}
                    position={"left"}
                  >
                    <div>
                      <Icone_signal
                        rssi={extension.capteur.rssi}
                        snr={extension.capteur.snr}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}

              {commentaire_a_valider && (
                <div
                  className={"item"}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(
                      "/commentaires?organisation=" +
                        extension.cellule?.organisation.id +
                        "&cellule=" +
                        extension.cellule?.nom
                    );
                  }}
                >
                  <Tooltip
                    label={"Accéder aux commentaires"}
                    position={"bottom"}
                  >
                    <div>
                      <StickyNote />
                    </div>
                  </Tooltip>
                </div>
              )}
            </div>

            {extension.capteur.error_code !== 0 && (
              <div
                className={"conditions"}
                style={{
                  justifyContent: "center",
                  backgroundColor: "var(--error-color)",
                  color: "White",
                  width: "calc(100% - 1rem)",
                }}
              >
                <div
                  className={"item"}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(
                      "/capteur/" +
                        extension.capteur.uuid +
                        "?cellule=" +
                        extension.cellule?.id
                    );
                  }}
                >
                  <CircleAlert /> Capteur en erreur{" "}
                  {extension.capteur.error_code}
                </div>
              </div>
            )}
          </>
        );
      }

      set_texte_final(_texte_final);
    }, [
      afficherEtatExtension,
      afficherTypeSiPasIcone,
      conditions,
      date_mesure,
      etalonnages,
      extension,
      selected,
      sonde,
      texte,
      titre,
    ]);

    return (
      <div
        className={
          "carte_mesure " +
          couleur +
          (bg_color ? " bg_color" : "") +
          (selected ? " selected" : "") +
          " " +
          (className ?? "")
        }
        onClick={handleClick}
        ref={ref}
        key={titre + texte + (extension?.id ?? 0)}
      >
        <div className={"titre"}>
          <i className="icone">{icone_svg}</i>
          <div className={"titre_container"}>
            <p
              className={"titre_texte" + (isOverflowing ? " slide" : "")}
              ref={titreRef}
            >
              {titre_jsx}
            </p>
          </div>
        </div>

        {bouton_icone && (
          <button
            className={"btn_custom_carte_mesure"}
            onClick={bouton_onclick}
          >
            <Icone nom={bouton_icone} />
          </button>
        )}

        <p className={"valeur"}>{texte_final}</p>

        <div className={"en-ligne spacebetween"} style={{ gap: "unset" }}>
          {conditions_affichage.length > 0 && afficherCondition ? (
            <>
              <div className={"conditions"}>{conditions_affichage}</div>
            </>
          ) : (
            <p></p>
          )}
        </div>
        {(etalonnage_affichage ||
          (commentaire_mesure && commentaire_mesure.length > 0)) && (
          <div
            className={"conditions"}
            style={{ justifyContent: "space-between" }}
          >
            {etalonnage_affichage ? (
              <Tooltip
                label={"Etalonnage actif."}
                position={"top"}
                style={{ fontSize: "var(--texte-size-petit)" }}
              >
                <div>
                  <Settings2 />
                </div>
              </Tooltip>
            ) : (
              <div></div>
            )}

            {commentaire_mesure &&
              commentaire_mesure.map((comm) => (
                <Tooltip
                  label={comm.commentaire}
                  position={"top"}
                  style={{ fontSize: "var(--texte-size-petit)" }}
                >
                  <div>
                    <StickyNote />
                  </div>
                </Tooltip>
              ))}
          </div>
        )}

        <div className={"en-ligne spacebetween"} style={{ gap: "unset" }}>
          {extension?.capteur.uuid ? (
            <>
              <div className={"conditions"} style={{ gap: "0.2rem" }}>
                <Cpu />
                {extension?.capteur.uuid}
              </div>

              {indicateurs}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
);
